import { AxiosInstance } from "axios";

export class BaseApi {
    constructor(protected readonly client: AxiosInstance) {}
}
